import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#4caf50',
      light: '#66bb6a',
      dark: '#2e7d32',
      contrastText: '#fff',
    },
    secondary: {
      main: '#2196f3',
      light: '#42a5f5',
      dark: '#1976d2',
      contrastText: '#fff',
    },
    background: {
      default: '#1a1a2e',
      paper: '#2a2a4e',
    },
    text: {
      primary: '#ffffff',
      secondary: '#cccccc',
    },
  },
  typography: {
    // « Noto Sans » est indispensable, pas décorative : le sous-ensemble latin de Roboto
    // ne contient pas les lettres du pulaar et des autres alphabets latins étendus
    // (Ɓ ɓ Ɗ ɗ Ŋ ŋ Ñ ñ Ƴ ƴ, ɛ ɔ ƙ…). Sans ce repli, le navigateur substitue une police
    // différente pour chaque glyphe manquant et le texte paraît corrompu.
    fontFamily: '"Roboto", "Noto Sans", "Segoe UI", "DejaVu Sans", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 500,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500,
      lineHeight: 1.3,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 500,
      lineHeight: 1.4,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 500,
      lineHeight: 1.4,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 500,
      lineHeight: 1.5,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 500,
      lineHeight: 1.6,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 8,
          padding: '8px 16px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
  },
});

export default theme;
